import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { AirportExact } from '../../../../../mission/models/Airport';

const AirportTreeView = ({ airports, setAirports, setCenteredGeometries, disabled }) => {
  const handleAirportsCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(airports, item.id));
    },
    [airports, setCenteredGeometries]
  );

  const handleAirportsVisibilityClick = useCallback(
    (item, isToggled) => {
      setAirports((oldAirports) => getEntitiesWithVisibility(oldAirports, item.id, isToggled));
    },
    [setAirports]
  );

  const { current: airportItemActions } = useRef([
    { id: 'airport-center', icons: { default: 'gps_fixed' }, onClick: handleAirportsCenterClick },
    {
      id: 'airport-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleAirportsVisibilityClick,
    },
  ]);

  const airportItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('patrol.details.airports')}: ${airports.length}`,
        actions: airportItemActions,
        disabled,
        children: airports.map((airport, index) => ({
          id: index,
          label: airport.name,
          actions: airportItemActions,
          disabled,
        })),
      },
    ],
    [airportItemActions, airports, disabled]
  );

  return <TreeView id="airports" items={airportItems} />;
};

AirportTreeView.propTypes = {
  airports: PropTypes.arrayOf(AirportExact),
  setAirports: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AirportTreeView.defaultProps = {
  airports: [],
  disabled: false,
};

export default AirportTreeView;
